import { AddBox, Edit } from "@mui/icons-material"

export const NewIcon = ({is_new}) => {
    if (is_new){
    return (
        <AddBox color="primary"/>
    )
    }else{

    return (
        <Edit color="warning"/>

    )
    }

}